import React, { useEffect, useState } from "react";
import { Select, Spin, Tabs } from "antd";
import {
  FormItem,
  FormikForm,
} from "../../../StyledComponents/CreateKeyAccountManager";

import { useDispatch } from "react-redux";
import { updatenotificationdata } from "../../../store/Admin/Common/CommonSlice";
import axios from "axios";
import styled from "styled-components";
import * as Yup from "yup";
import { SpinContainer } from "../../../StyledComponents/Queries";
import { useLocation } from "react-router-dom";
import AddIteneraryForm from "./AddIteneraryForm";
import AddAirlineForm from "./AddAirlineForm";
import { TopButtonDiv } from "../../../StyledComponents/RateManagement";
import SubmitButton from "../Common/SubmitButton";
import { HeadContainer } from "../../../StyledComponents/Dashboard";
import { httpinstance } from "../../../axios/api";

const { Option } = Select;
const FUEL_TYPE = [
  { label: "CNG", value: "CNG" },
  { label: "Diesel", value: "DIESEL" },
  { label: "Electric", value: "ELECTRIC" },
];

const validationSchema = Yup.object().shape({
  carrier: Yup.string().required("Carrier is required"),
  airlineName: Yup.string().required("Airline Name is required"),
  origin: Yup.string().required("Origin is required"),
  destination: Yup.string().required("Destination is required"),
  departureTime: Yup.string().required("Departure Time is required"),
  departuredays: Yup.array()
    .of(Yup.string().required("Each departure day is required"))
    .min(1, "At least one departure day is required")
    .required("Departure Days are required"),
  lat: Yup.string().required("Lat is required"),
  tao: Yup.string().required("TAO is required"),
  itinerary: Yup.array()
    .of(
      Yup.object().shape({
        origin: Yup.string().required("Origin is required"),
        destination: Yup.string().required("Destination is required"),
        departure: Yup.string().required("Departure is required"),
        arrival: Yup.string().required("Arrival is required"),
        aircraft: Yup.string().required("Aircraft is required"),
        flight: Yup.string().required("Flight is required"),
      })
    )
    .min(1, "At least one itinerary item is required"),
});

function AirlineDetailManagement(props) {
  const dispatch = useDispatch();
  const [spinner, setSpinner] = useState(false);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState(props.type);
  const [state, setState] = useState({
    countrie: [],
    state_list: [],
  });

  const handleCancel = (resetForm) => {
    setType("view");
    props.setType("view");
    resetForm();
  };

  const handleEdit = () => {
    setType("edit");
    props.setType("edit");
  };
  const handleSelectChange = (e, name, setFieldValue) => {
    setFieldValue([name], e);
  };

  const initialValues = {
    airlineName: "",
    origin: "",
    destination: "",
    departureTime: null,
    departuredays: [],
    arrivalDays :"",
    arrivalTime : null,
    lat: "",
    tao: "",
    itinerary: [
      {
        origin: "",
        destination: "",
        departureDay : 0,
        arrivalDay :"",
        departure: null,
        arrival: null,
        aircraft: "",
        flight: "",
      },
    ],
    ...props.instance,
    carrier: props.instance?.carrier?._id || "",
  };

  return (
    <FormikForm
      initialValues={initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm }) => {
        const data = {
          ...values,
          lat: Number(values.lat),
          tao: Number(values.tao),
          arrivalDays : Number(values.arrivalDays),
          itinerary : values?.itinerary?.map((item)=>({...item , departureDay : Number(item?.departureDay), arrivalDay : Number(item?.arrivalDay)}))

        };
        setSpinner(true);
        try {
          const result =
            type === "edit"
              ? await httpinstance.put(`flight-schedule/${values?._id}`, data)
              : await httpinstance.post("flight-schedule", data);

          if (
            result?.data?.statusCode === 200 ||
            result?.data?.statusCode === 201
          ) {
            let data = {
              message: result.data.message,
              statusCode: 200,
              success: result.data.success,
            };
            dispatch(updatenotificationdata(data));
            setSpinner(false);
            resetForm();
            props.setCallList(true);
            props.setPageType("table");
          }
        } catch (error) {
          console.log(error);
          setSpinner(false);
        }
      }}
    >
      {(formik) => (
        <FormItem className="airlineBookPadding PDDINGG0">
          <HeadContainer className="flexEnd">
            <TopButtonDiv className="mb-3">
              {type === "edit" || type === "create" ? (
                <>
                  {" "}
                  {type === "edit" ? (
                    <SubmitButton
                      type="button"
                      title="Cancel"
                      is_icon={false}
                      handleClick={() => handleCancel(formik.resetForm)}
                    />
                  ) : null}
                  <SubmitButton
                    type="submit"
                    title="save"
                    is_save={true}
                    loading={spinner}
                  />
                </>
              ) : (
                <SubmitButton
                  type="button"
                  title="Edit"
                  icon_type="edit"
                  handleClick={() => handleEdit()}
                />
              )}
            </TopButtonDiv>
          </HeadContainer>
          {spinner ? (
            <div className="flex justify-center items-center min-h-[200px]">
            <Spin />
          </div>
          ) : (
            <>
              <AddAirlineForm
                formikData={formik}
                airPort={props.airPort}
                airLineList={props.airLineList}
                type={type}
              />
              
              <AddIteneraryForm
                type={type}
                formikData={formik}
                airPort={props.airPort}
              />
            </>
          )}
        </FormItem>
      )}
    </FormikForm>
  );
}

export default AirlineDetailManagement;

const ItemSelect = styled(Select)`
  & .ant-select-selector {
    border-radius: 8px !important;
    padding: ${({ pdg }) => (pdg ? pdg : "unset")};
  }
  & .ant-select-selection-placeholder {
    color: #d9d9d9 !important;
    font-size: 16px;
    font-weight: 400;
  }
  & .ant-select-arrow {
    color: #d9d9d9 !important;
  }
  /* & .ant-select-selection-item {
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
    } */
`;
